import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store/index";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from './plugins/font-awesome';

const app = createApp(App);

app
  .directive("upper-case", {
    updated(el, binding) {
      if (binding.value) {
        el.value = el.value.toUpperCase();
        el.dispatchEvent(new Event('input'));
      }
    }
  });

app
  .use(router)
  .use(store)
  .component("font-awesome-icon", FontAwesomeIcon);

app
  .mount("#app");